// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1U0ad","list":"PatternAutocomplete_list__209_j"};